var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "other-cost-page" },
    [
      _c(
        "div",
        { staticClass: "workbench" },
        [
          _c("aside", { staticClass: "fee-sidebar" }, [
            _c(
              "div",
              { staticClass: "fee-list" },
              _vm._l(_vm.feeItems, function (item) {
                return _c(
                  "div",
                  {
                    key: _vm.getFeeCardKey(item),
                    staticClass: "fee-card",
                    class: {
                      active: _vm.activeFeeKey === _vm.getFeeCardKey(item),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectFeeItem(item)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "fee-card-main" }, [
                      _c("h3", { staticClass: "fee-title-row" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(_vm.QUOTATION_FEE_ITEM.bjGet(item.feeItem))
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "fee-meta-side centered" }, [
                        _c(
                          "div",
                          { staticClass: "fee-meta" },
                          [
                            _c("span", { staticClass: "meta-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("QuotationCenter.billingType")) +
                                  ":"
                              ),
                            ]),
                            _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "primary" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.QUOTATION_BILLING_TYPE.bjGet(
                                        item.billingType
                                      )
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "fee-meta" },
                          [
                            _c("span", { staticClass: "meta-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("QuotationCenter.chargeUnit")) +
                                  ":"
                              ),
                            ]),
                            _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "primary" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.QUOTATION_CHARGE_UNIT.bjGet(
                                        item.chargeUnit
                                      )
                                    )
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "fee-meta" },
                          [
                            _c("span", { staticClass: "meta-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("QuotationCenter.calcFuel")) + ":"
                              ),
                            ]),
                            _c("el-switch", {
                              attrs: {
                                value: Number(item.calcFuel) === 0,
                                disabled: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "fee-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "danger-text",
                            attrs: { type: "text", icon: "el-icon-delete" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.deleteFeeItem(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("delText")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-edit" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openFeeDialog(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("editText")))]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                staticClass: "add-fee-card",
                class: { disabled: !_vm.canAddFeeItem },
                on: { click: _vm.openAddFeeDialog },
              },
              [
                _c("i", { staticClass: "el-icon-plus" }),
                _c("span", [_vm._v(_vm._s(_vm.$t("QuotationCenter.add")))]),
              ]
            ),
          ]),
          _c("CostEditorPanel", { attrs: { "fee-item": _vm.activeFeeItem } }),
        ],
        1
      ),
      _c(
        "BjDialog",
        {
          attrs: {
            visible: _vm.feeDialogVisible,
            title: _vm.formTitle,
            width: "500px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.feeDialogVisible = $event
            },
            close: _vm.closeFeeDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "feeForm",
              staticClass: "fee-form",
              attrs: {
                model: _vm.feeForm,
                "label-position": "top",
                rules: _vm.feeFormRules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCenter.feeItem"),
                            prop: "feeItem",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t("QuotationCenter.feeItem"),
                              "option-list": _vm.feeItemOptions,
                            },
                            model: {
                              value: _vm.feeForm.feeItem,
                              callback: function ($$v) {
                                _vm.$set(_vm.feeForm, "feeItem", $$v)
                              },
                              expression: "feeForm.feeItem",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCenter.billingType"),
                            prop: "billingType",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCenter.billingType"
                              ),
                              "option-list": _vm.QUOTATION_BILLING_TYPE,
                            },
                            on: { change: _vm.handleBillingTypeChange },
                            model: {
                              value: _vm.feeForm.billingType,
                              callback: function ($$v) {
                                _vm.$set(_vm.feeForm, "billingType", $$v)
                              },
                              expression: "feeForm.billingType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCenter.chargeUnit"),
                            prop: "chargeUnit",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t("QuotationCenter.chargeUnit"),
                              "option-list": _vm.QUOTATION_CHARGE_UNIT,
                              disabled: "",
                            },
                            model: {
                              value: _vm.feeForm.chargeUnit,
                              callback: function ($$v) {
                                _vm.$set(_vm.feeForm, "chargeUnit", $$v)
                              },
                              expression: "feeForm.chargeUnit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("QuotationCenter.calcFuel"),
                            prop: "calcFuel",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              placeholder: _vm.$t("QuotationCenter.calcFuel"),
                              "option-list": _vm.QUOTATION_CALC_FUEL,
                            },
                            model: {
                              value: _vm.feeForm.calcFuel,
                              callback: function ($$v) {
                                _vm.$set(_vm.feeForm, "calcFuel", $$v)
                              },
                              expression: "feeForm.calcFuel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.closeFeeDialog } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmFeeDialog },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }